import React from "react";
import "../css/featured.css";
import Navbar from "../Navbar";
import ExploreMore from "../ExploreMore";

export const Women3 = () => {
  return (
    <>
      <Navbar />
      <div className="featured-con">
        <div className="layout">
          <h1 className="article-title">
            The Artist Turned HR Leader: Esi Mmirba Wilson's Blueprint for HR
            Excellence
          </h1>
          <div className="article-category">
            Africa's 10 Most Influential Women Leaders to Watch in 2024
          </div>
          <div className="share-container">
            <div className="share-buttons">
              <button className="share-button linkedin">LinkedIn</button>
              <button className="share-button twitter">Twitter</button>
              <button className="share-button facebook">Facebook</button>
            </div>
          </div>
          <div className="article-image-container">
            <img
              src="./images/Melissa-Munro.jpg"
              alt="Professional woman at desk"
              className="article-image"
            />
            <div className="article-image-caption">
              Esi Mmirba Wilson | Director, People and Transformation |
              Consolidated Bank Ghana
            </div>
          </div>
          {/* Article Content */}
          <div className="article-content">
            <p>
              Melissa Munro is an accomplished healthcare entrepreneur and
              registered nurse, known for her exceptional leadership skills and
              innovative thinking. With two health degrees with honours from the
              University of Western Ontario, she has founded several healthcare
              start-ups. Her most notable is Hero Care, a medical staffing app
              designed to connect healthcare providers with organizations
              addressing staffing shortages. Melissa facilitated over fifty
              clinics for the Ontario Ministry of Health’s Rapid Antigen Test
              Program, which provided COVID-19 screening for essential workers.
              Drawing on her extensive healthcare experience, she adapted to the
              unique demands of the pandemic to establish a vital healthcare
              service, demonstrating business acumen and dedication to community
              well-being. Melissa also founded and operates a successful
              skincare business and has recently taken on a directorship role
              with RHEA Foundation Canada, which supports humanitarian projects
              in remote and underserved areas of Africa. She won Digital Health
              Canada’s 2023 Women Leader in Digital Health Award, and Hero Care
              was selected as a finalist for the CanadianSME National Business
              Awards. I knew I wanted to be an entrepreneur when… I didn’t! When
              I started my own business, it started out as a passion. I knew I
              wanted to do something meaningful, that I would have appreciated
              as a nurse myself. Someone said to me “Oh, you’re an
              entrepreneur!” and I thought, “Wow, I guess I am, go me!”
              Entrepreneurship is made for me because… it gives me the power to
              take the lead and turn challenges into innovations. I love the
              freedom it gives me to be with my family and do other important
              work. The impact I hope to make through my work is… through Hero
              Care — to improve how we connect nurses to healthcare
              organizations, while giving them the flexibility they’ve been
              seeking and reducing the strain of staffing shortages in our
              healthcare system. Our app connects pre-vetted nurses directly to
              organizations, enabling them to find the right talent quickly and
              efficiently. Simply put, It’s a platform that brings supply and
              demand together in one user-friendly space. One of the most
              important lessons I’ve learned on my entrepreneurial journey is…
              you must be ready to take on anything, whether that be handling
              day-to-day operations, or meeting with top executives from
              potential prospects. Being hands-on in all aspects of your
              business allows you to understand its inner workings. At the same
              time, you can’t do everything, so learn to delegate where you can.
              My proudest accomplishment is… launching the app and seeing the
              first nurse sign up, connecting her to a job that supported the
              work-life balance she needed to stay in the profession. On the
              other end, we were able to support a facility going through
              significant staffing shortages. It’s in these moments where I’m
              re-affirmed that we are onto something that can change lives. The
              biggest risk I took that paid off was… quitting my secure job
              during the pandemic. It felt very scary at the time, but it was
              all I could think about. That decision led to the creation of Hero
              Care. My biggest setback has been… getting our product out there,
              and not being seen for what we are — something I struggle with
              everyday! Hero Care is not another nurse staffing agency. It’s a
              tech-powered platform with a mission to replace traditional
              agencies, offering a more efficient, affordable and compassionate
              solution to healthcare staffing. I overcame it by… persevering.
              Having experience as a bedside nurse, I know we have developed
              something amazing and powerful and won’t stop until every
              healthcare organization in Canada has seen it. The best advice
              I’ve received as an entrepreneur was… it’s okay to not know the
              answer to everything. Lean on your people to help you along in
              your journey. If you googled me, you still wouldn’t know… I’ve
              recently become involved with RHEA Foundation Canada, where I’ve
              been asked to take on a directorship role. The foundation, which
              has registered charity status in Canada, supports humanitarian
              projects in remote and underserved areas of Africa, focusing on
              access to healthcare, education and clean water. The future
              excites me because… it holds the promise of transforming
              healthcare staffing with our innovative tech solution. We know
              what the Hero Care app is capable of, and we can’t wait to see it
              being used to its full capacity. We are just getting started.
            </p>
          </div>
        </div>
      </div>
      <ExploreMore/>
    </>
  );
};
